export default __webpack_public_path__ + "static/media/delivery-receipts.133d52ce.svg";